import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import ErrorBoundary from "./context/ErrorBoundary";
import { DialogContextProvider } from "./context/DialogContext";
import { IdleTimeoutProvider } from "./components/IdleTimeout/IdleTimeoutProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <IdleTimeoutProvider>
        <DialogContextProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </DialogContextProvider>
      </IdleTimeoutProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
